var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4167 44.5833C86.5 28.3333 74.4583 14.7917 58.375 12.0417C58.125 8.83333 55.4583 6.25 52.1667 6.25H48C44.7083 6.25 42.0833 8.79167 41.7917 12C25.625 14.6667 13.5 28.25 12.5833 44.5833C9.625 45.0833 7.375 47.625 7.375 50.7083V54.875C7.375 58.3333 10.1667 61.125 13.625 61.125H17.7917C21.25 61.125 24.0417 58.3333 24.0417 54.875V50.7083C24.0417 47.625 21.7917 45.0833 18.8333 44.5833C19.7083 31.5833 29.25 20.7917 42 18.2917C42.7083 20.9583 45.125 22.9167 48 22.9167H52.1667C55.0417 22.9167 57.4167 20.9583 58.1667 18.3333C70.8333 20.875 80.2917 31.6667 81.1667 44.5833C78.2083 45.0833 75.9583 47.625 75.9583 50.7083V54.875C75.9583 58.3333 78.75 61.125 82.2083 61.125H86.375C89.8333 61.125 92.625 58.3333 92.625 54.875V50.7083C92.625 47.625 90.375 45.0417 87.4167 44.5833Z",
    fill: "#2ABC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7083 68.9583L58.875 75H41.1667L34.3333 68.9583C30.375 65.7083 30.375 63.2083 33.375 59.375L45.4167 44.125C46.25 43.0833 47.2083 42.375 48.2917 42C49.4167 41.625 50.625 41.625 51.7917 42C52.8333 42.375 53.7917 43.0833 54.6667 44.125L66.6667 59.3333C69.7083 63.1667 69.5417 65.5417 65.7083 68.9583Z",
    fill: "#2ABC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 91.6666H44.7083C40.875 91.6666 38 88.5416 38.75 85.2083L40.0417 79.4166C40.2917 78.2499 41.3333 77.4583 42.5 77.4583H57.7083C58.875 77.4583 59.875 78.2499 60.1667 79.4166L61.4583 85.2083C62.25 88.7499 59.5833 91.6666 55.5 91.6666Z",
    fill: "#2ABC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenTool);
export default __webpack_public_path__ + "static/media/pen-tool.fcc40eddd37386c82634700c97bda547.svg";
export { ForwardRef as ReactComponent };